/**
 * Categories shown in the AUP (Acceptable Use Policy) feedback flow when a
 * user reports a positive-side AUP issue.
 */
export const AUP_POSITIVE_CATEGORIES = ['helpful', 'other'] as const;
